import { Client } from "../../../client";

// The IPO list endpoints return Laravel-paginated payloads:
//   { <key>: [...rows], meta: { total, per_page, current_page, last_page }, ...rest }
// with a 20-row default page. This walks every page (?page=N, driven by
// meta.last_page) and returns the same payload shape with all rows merged,
// so callers and the table never see a truncated set.
export const fetchAllIpoPages = async ({ path, key, perPage = 100 }) => {
  const getPage = async (page, per_page) => {
    const response = await Client({
      method: "GET",
      path,
      queryParams: { page, per_page },
    });
    return response?.data?.data || {};
  };

  const first = await getPage(1, perPage);
  const meta = first?.meta || {};
  const lastPage = Number(meta?.last_page || 1);
  // If the server ignores per_page, meta.per_page tells us what it used.
  const serverPerPage = Number(meta?.per_page || perPage);

  let rows = Array.isArray(first?.[key]) ? first[key] : [];

  if (lastPage > 1) {
    const pages = [];
    for (let page = 2; page <= lastPage; page += 1) {
      pages.push(getPage(page, serverPerPage));
    }
    const rest = await Promise.all(pages);
    rest.forEach((payload) => {
      if (Array.isArray(payload?.[key])) {
        rows = rows.concat(payload[key]);
      }
    });
  }

  return {
    ...first,
    [key]: rows,
    meta: { ...meta, current_page: 1, per_page: rows.length, last_page: 1 },
  };
};
